// extracted by mini-css-extract-plugin
module.exports = {"playChipsMessage":"_49f8fb6"};